// extracted by mini-css-extract-plugin
export var container = "SpeechBabble-module--container--b01a9";
export var text = "SpeechBabble-module--text--795c3";